/**
 * Jungle Calling — lightweight quick view.
 * Opens the inline quick-view dialog for a card and adds to cart through the Shopify AJAX Cart API.
 * The markup is rendered server-side in snippets/jc-card-quick-view.liquid.
 */
(function () {
  'use strict';

  var OPEN_CLASS = 'jc-qv--open';
  var BODY_CLASS = 'jc-qv-open';

  function closeAll(except) {
    document.querySelectorAll('.jc-qv.' + OPEN_CLASS).forEach(function (root) {
      if (root === except) return;
      root.classList.remove(OPEN_CLASS);
      root.hidden = true;
      if (root.__jcQvOpener) {
        root.__jcQvOpener.focus({ preventScroll: true });
        root.__jcQvOpener = null;
      }
    });
    if (!document.querySelector('.jc-qv.' + OPEN_CLASS)) {
      document.body.classList.remove(BODY_CLASS);
    }
  }

  function open(root, opener) {
    closeAll(root);
    root.hidden = false;
    root.__jcQvOpener = opener || null;
    // let the browser paint the hidden -> visible change so the transition runs
    requestAnimationFrame(function () {
      root.classList.add(OPEN_CLASS);
      document.body.classList.add(BODY_CLASS);
    });
    var dialog = root.querySelector('.jc-qv__dialog');
    if (dialog) dialog.focus({ preventScroll: true });
  }

  function note(root, message, isError) {
    var el = root.querySelector('[data-jc-qv-note]');
    if (!el) return;
    el.textContent = message;
    el.classList.toggle('is-error', !!isError);
    el.classList.toggle('is-success', !isError);
  }

  function showCartIndicator() {
    // Let the theme's cart drawer / bubble know the cart changed.
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) {
      bubble.classList.remove('cart-count-bubble--bump');
      void bubble.offsetWidth;
      bubble.classList.add('cart-count-bubble--bump');
    }
  }

  function addToCart(root, button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    var label = button.querySelector('.button__label');
    var original = label ? label.textContent.trim() : '';
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    if (label) label.textContent = '…';
    note(root, '', false);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error((data && data.description) || 'Could not add to cart');
          return data;
        });
      })
      .then(function () {
        note(root, 'Added to cart', false);
        showCartIndicator();
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var count = document.querySelector('.cart-count-bubble');
        if (count && cart) {
          var value = count.querySelector('span[aria-hidden="true"]') || count;
          value.textContent = String(cart.item_count);
          count.classList.remove('visually-hidden');
        }
      })
      .catch(function (error) {
        note(root, error && error.message ? error.message : 'Could not add to cart', true);
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (label) label.textContent = original;
      });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-jc-qv-open]');
    if (opener) {
      var productId = opener.getAttribute('data-jc-qv-open');
      var root = document.querySelector('[data-jc-qv][data-jc-qv-product="' + productId + '"]');
      if (root) {
        event.preventDefault();
        event.stopPropagation();
        open(root, opener);
      }
      return;
    }

    var closer = event.target.closest('[data-jc-qv-close]');
    if (closer) {
      var openRoot = closer.closest('.jc-qv');
      if (openRoot) {
        event.preventDefault();
        closeAll(null);
      }
      return;
    }

    var addButton = event.target.closest('[data-jc-qv-add]');
    if (addButton) {
      event.preventDefault();
      var rootForAdd = addButton.closest('.jc-qv');
      if (rootForAdd) addToCart(rootForAdd, addButton);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll(null);
  });

  // Cards can sit inside transformed/overflow-hidden containers, which breaks position:fixed.
  // Move every dialog to <body> once, so the overlay always covers the viewport.
  function detachDialogs(scope) {
    try {
      (scope || document).querySelectorAll('.jc-qv').forEach(function (root) {
        if (root.parentElement !== document.body) document.body.appendChild(root);
      });
    } catch (error) {
      /* never let a theme-editor re-render break the dialog */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { detachDialogs(document); });
  } else {
    detachDialogs(document);
  }

  // The theme editor fires section:load a lot; only move newly rendered dialogs,
  // never touch an open one (that used to close the dialog right after it opened).
  document.addEventListener('shopify:section:load', function (event) {
    if (document.querySelector('.jc-qv.' + OPEN_CLASS)) return;
    if (event && event.target) detachDialogs(event.target);
  });
})();
